module.exports = __webpack_public_path__ + "static/img/down3.b214991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down3.png
// module id = B+zh
// module chunks = 1